// frontend/apps/widgets/src/widgets/GiftVoucher/components/NoVouchersDisplay.js
import React from 'react';
import {Card, Typography, Box} from '@mui/material';
import GiftIcon from '@mui/icons-material/CardGiftcard';

const NoVoucherDisplay = () => {
  return (
    <Card sx={{
      textAlign: 'center',
      padding: '2rem',
      margin: '2rem 0',
      boxShadow: (theme) => theme.shadows[2],
      borderRadius: 2,
    }}>
      <Box>
        <GiftIcon sx={{fontSize: 60, marginBottom: '1rem', color: 'primary.main'}} />
        <Typography variant="h5" gutterBottom>
          Aucun bon cadeau disponible
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Ce commerce n&apos;a pas encore créé de bons cadeaux.
        </Typography>
      </Box>
    </Card>
  );
};

export default NoVoucherDisplay;
